import { render, staticRenderFns } from "./BaseFrontOfficeChatMessage.vue?vue&type=template&id=3bbf1aaa&scoped=true"
import script from "./BaseFrontOfficeChatMessage.vue?vue&type=script&lang=js"
export * from "./BaseFrontOfficeChatMessage.vue?vue&type=script&lang=js"
import style0 from "./BaseFrontOfficeChatMessage.vue?vue&type=style&index=0&id=3bbf1aaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbf1aaa",
  null
  
)

export default component.exports